import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { firebaseApp } from './firebase';

const messaging = getMessaging(firebaseApp);

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      return getToken(messaging, {
        vapidKey: process.env.REACT_APP_WEB_PUSH_CERTIFICATE_KEY_PAIR,
      });
    }
    throw new Error('Notification permission denied');
  } catch (error) {
    console.log('Error getting notification permission:', error);
    throw error;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
